var map = {
	"./2014宣传册.jpg": 22655,
	"./2015宣传册.jpg": 21544,
	"./2016宣传册.jpg": 21813,
	"./2017宣传单.jpg": 95931,
	"./2019宣传页.jpg": 99969,
	"./2020宣传页.jpg": 48321,
	"./2021宣传页.jpg": 36238,
	"./2022宣传页.jpg": 18943,
	"./2023宣传页.jpg": 48820,
	"./2024宣传页.jpg": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25934;